import { filter, first, isEmpty } from "lodash";
import PropTypes from "prop-types";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeAll as handleChangeAllAction } from "../../actions/handleChangeAction";
import { getIleggelseRettelser } from "../../actions/ileggelseRettelserActions";
import {
  addKlageIleggelse,
  getIleggelseDetailByNummer,
  getKlageIleggelser,
  setKlageIleggelseInReducer,
} from "../../actions/klager/klageAction";
import {
  addKlageVedtak,
  getKlageVedtaker,
} from "../../actions/klager/vedtakAction";
import { getMiljoRettelser } from "../../actions/miljoRettelserActions";
import { IsValidated, onChangeValidation } from "../../utils/validationUtils";
import AddIleggelseToKlageModal from "./AddIleggelseToKlageModal";

const rules = {
  ileggelsenummer: "required;isDigit",
};

function IleggelseTabContainer({
  changeSelectedTab,
  onAddIleggelse,
  manglerInfo,
}) {
  const dispatch = useDispatch();
  const klageId = useSelector((state) =>
    state.klageDetail && state.klageDetail.id ? state.klageDetail.id : "",
  );
  const vedtaker = useSelector((state) => state.vedtaker);

  const [open, setOpen] = useState(false);
  const [ileggelsenummer, setIleggelsenummer] = useState("");
  const [validationError, setValidationError] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [showSubmitSpinner, setShowSubmitSpinner] = useState(false);

  const closeModal = () => {
    setOpen(false);
    setValidationError({});
    setIleggelsenummer("");
  };

  const openModal = () => setOpen(true);

  const checkIsValid = () => {
    const clonedValidationError = { ...validationError };
    const { isValid, validationError: ve } = IsValidated(
      { ileggelsenummer, validationError: clonedValidationError },
      rules,
    );
    setValidationError(ve);
    return isValid;
  };

  const handleChange = (e) => {
    setIleggelsenummer(e.target.value);
    onChangeValidation(e, { ileggelsenummer, validationError }, rules);
  };

  const getIleggelseTilbakeMeldinger = (ileggelse) => {
    const ileggelseId = ileggelse.id;
    const ileggelsetype = ileggelse.ileggelsestypeId;
    ileggelsetype && ileggelsetype !== 5
      ? dispatch(getIleggelseRettelser(ileggelseId))
      : dispatch(getMiljoRettelser(ileggelseId));
  };

  const vedtaksIleggelseNotExists = (ileggelsesnummer) => {
    const ileggelse = first(
      filter(vedtaker, (i) => {
        return i.ileggelsesnummer.toString() === ileggelsesnummer.toString();
      }),
    );
    return isEmpty(ileggelse);
  };

  const addIleggelseToKlageOgVedtak = (e) => {
    e.preventDefault();
    if (checkIsValid()) {
      dispatch(getIleggelseDetailByNummer(ileggelsenummer, null, false)).then(
        (ileggelse) => {
          if (ileggelse && ileggelse.ileggelsesnummer) {
            setDisabled(true);
            setShowSubmitSpinner(true);
            dispatch(addKlageIleggelse(klageId, ileggelse))
              .then(async () => {
                await dispatch(setKlageIleggelseInReducer(ileggelse));
                getIleggelseTilbakeMeldinger(ileggelse);
                await dispatch(getKlageIleggelser(klageId));
                await onAddIleggelse(ileggelse.ileggelsesnummer);
                if (vedtaksIleggelseNotExists(ileggelse.ileggelsesnummer)) {
                  var klagevedtak = await dispatch(
                    addKlageVedtak(klageId, ileggelse),
                  ).catch(() => {
                    setDisabled(false);
                    setShowSubmitSpinner(false);
                    setOpen(false);
                    setIleggelsenummer("");
                  });
                  if (klagevedtak && klagevedtak.id) {
                    const klagevedtaker = await dispatch(
                      getKlageVedtaker(klageId),
                    );
                    if (Array.isArray(klagevedtaker)) {
                      const vedtakerForm = klagevedtaker.reduce(
                        (object, kv) => {
                          object[kv.id] = {
                            vedtakskode: kv.vedtakskodeId,
                            validationError: {},
                          };
                          return object;
                        },
                        {},
                      );
                      dispatch(
                        handleChangeAllAction(
                          "KLAGE_VEDTAKER_FORM",
                          vedtakerForm,
                        ),
                      );
                    }
                  }
                }
                setOpen(false);
                setIleggelsenummer("");
                setDisabled(false);
                setShowSubmitSpinner(false);
              })
              .catch(() => {
                setDisabled(false);
                setShowSubmitSpinner(false);
              });
          } else {
            setValidationError({
              ileggelsenummer: `Fant ikke ileggelse/miljøgebyr med ileggelsesnummer ${ileggelsenummer}.`,
            });
            setOpen(true);
            setDisabled(false);
            setShowSubmitSpinner(false);
          }
        },
      );
    }
  };

  return (
    <AddIleggelseToKlageModal
      open={open}
      openModal={openModal}
      closeModal={closeModal}
      handleChange={handleChange}
      ileggelsenummer={ileggelsenummer}
      onSubmit={addIleggelseToKlageOgVedtak}
      disabled={disabled || manglerInfo}
      showSubmitSpinner={showSubmitSpinner}
      id="addIleggelser"
      validationError={validationError}
    />
  );
}

IleggelseTabContainer.propTypes = {
  klageId: PropTypes.string,
  changeSelectedTab: PropTypes.func,
  onAddIleggelse: PropTypes.func,
  manglerInfo: PropTypes.bool,
};

export default IleggelseTabContainer;
